import React from 'react';
import { reduxForm, Field, FormSection } from 'redux-form';
import FormField from '../../forms/FormField';

import { Button, Row, Col } from 'react-bootstrap';

const colorOptions = [
  { label: 'Red', value: 'red' },
  { label: 'Yellow', value: 'yellow' },
  { label: 'Blue', value: 'blue' },
  { label: 'Green', value: 'green' },
  { label: 'Purple', value: 'purple' },
  { label: 'Grey', value: 'grey' },
]

const TagsForm = props => {
  const { handleSubmit, pristine, reset, submitting, cancelEdit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div className="form">
        <Row>
          <Col sm={12}>
            <Field
              name="value"
              type="text"
              component={FormField.Input}
              label="Tag"
              autoComplete="off"
              validate={value => value ? undefined : 'Required'}
            />
            <Field
              name="color"
              type="text"
              component={FormField.Select2}
              options={colorOptions}
              label="Color"
              validate={value => value ? undefined : 'Required'}
            />
          </Col>
        </Row>
      </div>
      <div className="text-right">
        <Button bsStyle="hollow-info" type="button" disabled={submitting} onClick={cancelEdit}>
          <span className="ti ti-close" /> Cancel
        </Button>
        {' '}
        <Button bsStyle="success" type="submit" disabled={submitting}>
          <span className="ti ti-check" /> Submit
        </Button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'tags-form', // a unique identifier for this form
})(TagsForm);



// WEBPACK FOOTER //
// ./src/components/routes/tags/TagForm.js